export const exportToCsv = (dataList, keys, columnNames = null) => {
  const escapeValue = (value) => {
    if (value === null || value === undefined) return '';
    const stringValue = String(value);
    // Escape quotes and wrap if needed
    if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
  };

  const resolvedColumnNames = Array.isArray(columnNames) && columnNames.length === keys.length
    ? columnNames
    : keys;

  const header = resolvedColumnNames
    .map(name => escapeValue(name))
    .join(',');

  const rows = dataList.map(item =>
    keys
      .map(key => escapeValue(item?.[key]))
      .join(',')
  );

  return [header, ...rows].join('\n');
};

export const downloadCsv = (csvContent, filename) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};